var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"chat-widget-container"},[(_vm.sierraExperiment)?_c('SierraWidget'):_vm._e(),(!_vm.sierraExperiment && !_vm.hideChatWidget)?_c('GladlyWidget'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }